<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center gap-5">
                    <h2 class="mb-0">Entries</h2>
                </div>
                <button mat-raised-button (click)="createManuallySendEntry()">
                    Manually Send <mat-icon>send</mat-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
                [filter]="filter" [data]="entries" (filterChanged)="getEntries()" (filterReset)="resetFilter()">
            </gt-table>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <table mat-table [dataSource]="entries" matSort (matSortChange)="sortData($event)">
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">First Name</th>
                    <td mat-cell *matCellDef="let entry">{{entry.firstName}}</td>
                </ng-container>

                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">Last Name</th>
                    <td mat-cell *matCellDef="let entry">{{entry.lastName}}</td>
                </ng-container>

                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</th>
                    <td mat-cell *matCellDef="let entry">{{entry.emailAddress}}</td>
                </ng-container>
                
                <ng-container matColumnDef="booking">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="booking">Booking</th>
                    <td mat-cell *matCellDef="let entry">{{entry.confirmationNumber}}</td>
                </ng-container>

                <ng-container matColumnDef="signature">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="signature">Signature</th>
                    <td mat-cell *matCellDef="let entry">{{entry.signature}}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
                    <td mat-cell *matCellDef="let entry">
                        <true-false *ngIf="entry.signature" [value]="true" [trueMatIcon]="'check_circle'" [trueText]="'Signed'"></true-false>
                        <true-false *ngIf="!entry.signature" [value]="false" [falseMatIcon]="'error_outline'" [falseText]="'Not Signed'"></true-false>
                    </td>
                </ng-container>

                <ng-container matColumnDef="lastEditedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="lastEditedDate">Last Edited Date</th>
                    <td mat-cell *matCellDef="let entry">{{entry.lastEditedDate | date: 'MMM d, y, h:mm a'}}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let entry">
                        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionsMenu>
                            <button mat-menu-item (click)="openQuickview(entry)">
                                <mat-icon>visibility</mat-icon>
                                <span>Quick View</span>
                            </button>
                            <button mat-menu-item (click)="resendWaiver(entry)" *ngIf="canResendWaiver(entry)">
                                <mat-icon>send</mat-icon>
                                <span>Resend</span>
                            </button>
                            <button mat-menu-item (click)="delete(entry)">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>
